import React from 'react';
import { connect, useSelector } from 'react-redux';

import { BALANCE_ISSUE, MIN_AMOUNT_ISSUE } from 'apps/auth/constants/Constants';
import { AMOUNT_FROM } from 'apps/auth/constants/fieldsName';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useForm, useLanguage } from 'apps/auth/hooks/selectors';

import DcGaAccount from './DcGaAccount';

const DcGaAccounts = (props) => {
    const { fields } = useForm(props.formName);
    const { country } = useApp();
    const { lang } = useLanguage();
    const fromRestriction = props.paymentMethod?.commission?.restrictionFrom;
    const currencyIso = props.paymentMethod?.currencyIso;
    const amountFrom = fields[AMOUNT_FROM].value;
    const { gaBalanceNotEnough, methodMinInfo } = useSelector(({ messages: { pageMessages } }) => pageMessages);

    const getIssueType = (value, min, _max, balance) => {
        let issueType;
        const fValue = parseFloat(value);
        const fBalance = parseFloat(balance);
        const fMin = parseFloat(min);

        if (fValue > fBalance) {
            issueType = BALANCE_ISSUE;
        } else if (fValue < fMin) {
            issueType = MIN_AMOUNT_ISSUE;
        }

        return issueType;
    };

    const getPopupTitle = (props, amountFrom, amountIssue, restriction, currencyIso, methodMinInfo, gaBalanceNotEnough, accountBalance) => {
        const minAmount = restriction?.minAmount;
        if (amountIssue === MIN_AMOUNT_ISSUE) {
            return resolveArguments(methodMinInfo, [`${getLocalizedRawAmount(lang, country, minAmount)} ${currencyIso}`, props.name]);
        } else if (amountIssue === BALANCE_ISSUE) {
            const delta = amountFrom - accountBalance;
            return resolveArguments(gaBalanceNotEnough, [
                `${getLocalizedRawAmount(lang, country, accountBalance)} ${currencyIso}`,
                `${getLocalizedRawAmount(lang, country, delta)} ${currencyIso}`,
            ]);
        }
    };

    if (Array.isArray(props.accounts) && props.accounts.length > 0) {
        return (
            <>
                {props.accounts.map((account) => {
                    const issueType = getIssueType(amountFrom, fromRestriction?.minAmount, fromRestriction?.maxAmount, account.balance);
                    const popupText = getPopupTitle(
                        props,
                        amountFrom,
                        issueType,
                        fromRestriction,
                        currencyIso,
                        methodMinInfo,
                        gaBalanceNotEnough,
                        account.balance,
                    );
                    return (
                        <DcGaAccount
                            fields={props.fields}
                            balance={account.balance}
                            isNotEnoughFunds={issueType === BALANCE_ISSUE}
                            isBelowMinAmount={false}
                            popupText={popupText}
                            paymentMethod={props.paymentMethod}
                            formName={props.formName}
                            account={account}
                            clickHandler={props.clickHandler}
                            returnToCalculator={props.returnToCalculator}
                            messages={props.messages}
                            key={account.code}
                            temporarilyUnavailableReason={account.temporarilyUnavailableReason}
                            isTemporarilyUnavailableSource={account.temporarilyUnavailableSource}
                            recipientType={props.recipientType}
                        />
                    );
                })}
            </>
        );
    } else {
        return false;
    }
};

const mapStateToProps = ({ messages, form }) => {
    return {
        fields: form[SEND_FORM_NAME].fields,
        messages: messages,
    };
};
export default connect(mapStateToProps)(DcGaAccounts);
